module.exports = __webpack_public_path__ + "static/media/file.a583fe01.svg";